import './LoadingPage.scss';

function LoadingPage() {
  return (
    <div className="loading-page">
      <div className="loader">
        <div className="logo">
          <img src="/images/acklio_logo.svg" alt="Logo" />
        </div>
        <div className="loader__bar">
          <div className="loader__bar--filled" />
        </div>
      </div>
    </div>
  );
}

export default LoadingPage;
